import apiClient from './api'

export default {
  stats() {
    return apiClient.get('/admin/llm-cache/stats')
  },
  list(page = 1, perPage = 25) {
    return apiClient.get('/admin/llm-cache', { params: { page, per_page: perPage } })
  },
  show(key) {
    return apiClient.get(`/admin/llm-cache/${encodeURIComponent(key)}`)
  },
  invalidate(key) {
    return apiClient.delete(`/admin/llm-cache/${encodeURIComponent(key)}`)
  },
  clearAll() {
    return apiClient.delete('/admin/llm-cache')
  },
}

